import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { States } from '../model/states';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from '../../environments/environment.prod';


@Injectable({
    providedIn: 'root'
})

export class FormService {

      httpOptions = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json' 
          })
      };

    apiUrl = environment.apiURL;

    constructor(private http: HttpClient) {

    }

    // getFormData(): Observable<any> {
    //     return this.http.get(this.apiUrl + 'questions/questionswithoptions');
    // }
    getFormData(filter): Observable<any> {
        return this.http.get(this.apiUrl + 'questions/questionswithoptions'+'?filter='+encodeURIComponent(JSON.stringify(filter)));
    }

    

}
